import { useState } from 'react';
import { motion } from 'framer-motion';
import { FaChevronRight, FaChevronLeft } from 'react-icons/fa6';
import classNames from 'classnames';
import { PageContainer } from './page-container';

interface PageWithSidebarLayoutProps {
  sidebar: React.ReactNode;
  children: React.ReactNode;
}

const SIDEBAR_WIDTH = 470;

export function PageWithSidebarLayout({ sidebar, children }: PageWithSidebarLayoutProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <PageContainer>
      <div className="grid grid-cols-[auto_1fr]">
        <motion.aside
          className="overflow-hidden relative"
          initial={{ width: SIDEBAR_WIDTH }}
          animate={{ width: isOpen ? SIDEBAR_WIDTH : 0 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <motion.div
            className="flex flex-col overflow-hidden h-full"
            style={{ width: SIDEBAR_WIDTH }}
            initial={{ x: 0 }}
            animate={{ x: isOpen ? 0 : -SIDEBAR_WIDTH }}
            transition={{ duration: 0.3, ease: 'easeInOut' }}
          >
            {sidebar}
          </motion.div>
          <button
            onClick={() => setIsOpen(false)}
            className={classNames(
              'absolute right-2 top-[2.0rem] z-10 rounded-full p-1 hover:bg-brand-primary-hover transition-colors',
              !isOpen && 'hidden',
            )}
          >
            <FaChevronLeft className="text-white w-4 h-4" />
          </button>
        </motion.aside>
        <div className="relative">
          <button
            onClick={() => setIsOpen(true)}
            className={classNames(
              'absolute -left-4 top-[2.0rem] z-10 p-2 rounded-r-lg hover:bg-brand-primary-hover transition-all',
              isOpen ? 'opacity-0 pointer-events-none' : 'opacity-100',
            )}
          >
            <FaChevronRight className="text-white w-4 h-4" />
          </button>
          {children}
        </div>
      </div>
    </PageContainer>
  );
}
